import Modal from "react-modal";
import styled from "styled-components";
import xBtn from "../../image/x.png";
import { useEffect } from "react";
import { useState } from "react";
import { useForm } from "react-hook-form";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import SaveAlert from "../Alert/SaveAlert";
import { useRecoilValue } from "recoil";
import { accessTokenAtom } from "../../recoil/auth";
import { modifyDevice } from "../../apis/api/Device/modifyDevice";
import { useTranslation } from "react-i18next";
import { Button, Switch } from "@mui/material";

const convertDataArrayToInputValues = (dataArray) => {
  const inputValues = {};
  dataArray.forEach((data, index) => {
    const textKey = `text${index + 1}`;
    inputValues[textKey] = `${data.lat},${data.lon}`;
  });
  return inputValues;
};

const convertDataArrayToInputValues2 = (dataArray) => {
  const inputValues = {};
  dataArray.forEach((data, index) => {
    const rangeKey = `range${index + 1}`;
    inputValues[rangeKey] = `${data.range}`;
  });
  return inputValues;
};

const geoInputs = [
  { text: "text1", range: "range1" },
  { text: "text2", range: "range2" },
  { text: "text3", range: "range3" },
];

export default function ModifyDeviceModal({ isOpen, isClose }) {
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [popup, setPopup] = useState(null);
  const {
    register,
    watch,
    handleSubmit,
    setValue,
    reset,
    formState: { errors },
  } = useForm({ defaultValues: { type: "" } });
  const accessToken = useRecoilValue(accessTokenAtom);
  const queryClient = useQueryClient();
  const [deviceList, setDeviceList] = useState([]);
  const [categoryList, setCategoryList] = useState([]);
  const [inputValues, setInputValues] = useState({});
  const [inputValues2, setInputValues2] = useState({});
  const [postValue, setPostValue] = useState([]);
  const [postJsonInputString, setPostJsonInputString] = useState("");
  const modifyDeviceMutation = useMutation(modifyDevice, {
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["devices"] });
      queryClient.invalidateQueries({ queryKey: ["categories"] });
      SaveAlert();
      reset(); // useForm 초기화
      closeModal();
    },
  });
  const { t } = useTranslation();

  useEffect(() => {
    if (isOpen === true) {
      reset();
      const deviceData = queryClient.getQueryData(["devices"]);
      const categoryData = queryClient.getQueryData(["categories"]);
      setDeviceList(deviceData);
      setCategoryList(categoryData);
      setModalIsOpen(true);
    } else {
      closeModal();
    }
  }, [isOpen]);

  function closeModal() {
    setModalIsOpen(false);
    isClose(false);
  }

  const onVaild = (formData) => {
    if (formData.serial === "none") {
      alert(t(`select device`) + "!");
      return;
    }
    const transformedData = {
      ...formData,
      isSaveLog: formData.isSaveLog ? 'y' : 'n',
    };
    modifyDeviceMutation.mutate({ formData: transformedData, accessToken });
  };

  const handleDeviceSelect = (event) => {
    const selectedDeviceSerial = event.target.value;
    if (selectedDeviceSerial === "none") {
      setValue("category", "");
      setValue("type", "");
      setValue("name", "");
      setValue("info", "");
      setValue("geo", "");
      setValue("isSaveLog", "");
    }
    const selectedDeviceData = deviceList.find(
      (device) => device.serial === selectedDeviceSerial
    );
    setPostJsonInputString("");
    if (selectedDeviceData) {
      setValue("category", selectedDeviceData.categoryName);
      setValue("type", selectedDeviceData.type);
      setValue("name", selectedDeviceData.name);
      setValue("info", selectedDeviceData.info);
      setValue("geo", selectedDeviceData.geo);
      setValue("isSaveLog", selectedDeviceData.isSaveLog);
      if (selectedDeviceData.geo) {
        setInputValues(
          convertDataArrayToInputValues(JSON.parse(selectedDeviceData.geo))
        );
        setInputValues2(
          convertDataArrayToInputValues2(JSON.parse(selectedDeviceData.geo))
        );
        setPostJsonInputString(selectedDeviceData.geo);
      } else {
        geoInputs.forEach((input) => {
          document.getElementById(input.text).value = "";
          document.getElementById(input.range).value = "";
        });
        setInputValues({});
        setInputValues2({});
      }
    }
  };

  useEffect(() => {
    if (popup) {
      window.addEventListener("message", (event) => {
        if (event.data.text1 !== undefined) {
          const dataArray = Object.keys(event.data)
            .filter((key) => key.startsWith("text"))
            .map((key) => {
              const [lat, lon] = event.data[key]
                .split(",")
                .map((coord) => parseFloat(coord.trim()));
              const range = parseFloat(
                event.data[`range${key.slice(-1)}`].trim()
              );
              return { lat: lat || 0, lon: lon || 0, range: range || 0 };
            });
          setPostValue(JSON.stringify(dataArray));
          setInputValues(
            Object.fromEntries(
              Object.keys(event.data)
                .filter((key) => key.startsWith("text"))
                .map((key) => [key, `${event.data[key]}`])
            )
          );
          setInputValues2(
            Object.fromEntries(
              Object.keys(event.data)
                .filter((key) => key.startsWith("range"))
                .map((key) => [key, parseFloat(event.data[key].trim()) || 0])
            )
          );
          setValue("geo", JSON.stringify(dataArray));
          setPostJsonInputString(JSON.stringify(dataArray));
        }
      });
    }
  }, [popup]);

  const handleButtonClick = () => {
    if (!popup || popup.closed) {
      const newPopup = window.open(
        `/geotest?json=${postJsonInputString}`,
        "LocationSettingPopup",
        "width=1200,height=800"
      );
      setPopup(newPopup);
    } else {
      popup.focus();
    }
  };

  return (
    <Modal
      style={{
        overlay: {
          zIndex: 100,
          width: "100%",
          height: "100vh",
          backgroundColor: "rgba(100, 100, 100, 0.3)",
          transition: "opacity 0.5s ease",
          top: "0",
          position: "fixed",
        },
        content: {
          width: "500px",
          height: "fit-content",
          backgroundColor: "#ebecee",
          borderRadius: "15px",
          overflow: "hidden",
          position: "absolute",
          left: "50%",
          top: "45%",
          transform: `translate(-50%, -50%)`,
        },
      }}
      isOpen={modalIsOpen}
      onRequestClose={closeModal}
      ariaHideApp={false}
    >
      <ModalContainer>
        <Title>{t(`modify device`)}</Title>
        <XBtn onClick={closeModal} />
        <FormContainer>
          <InputForm onSubmit={handleSubmit(onVaild)}>
            <InputLabel>
              {t(`select device`)}
              <ErrorMsg>{errors?.serial?.message}</ErrorMsg>
            </InputLabel>
            <Select
              {...register("serial", { required: `* ${t(`required`)}` })}
              onChange={handleDeviceSelect}
            >
              <Option value="none">{t(`please select`)}</Option>
              {deviceList?.map((device) => {
                return <Option key={device.serial}>{device.serial}</Option>;
              })}
            </Select>

            <InputLabel>{t(`category`)}</InputLabel>
            <Select {...register("category")}>
              {categoryList?.map((category, index) => {
                return (
                  <Option key={index}>
                    {category.categoryName}
                  </Option>
                );
              })}
            </Select>
            <InputLabel>{t(`device type`)}</InputLabel>
            <Select {...register("type")}>
              <Option>RTAP2U</Option>
              <Option>RTK2U</Option>
            </Select>
            <InputLabel>{t(`device name`)}</InputLabel>
            <Input
              {...register("name", {
                required: `* ${t(`please enter`)}`,
              })}
            />
            {geoInputs.map((input, index) => (
              <div key={index} style={{ display: "flex", margin: "4px 0" }}>
                <input
                  {...register(input.text)}
                  type="text"
                  id={input.text}
                  style={{
                    outline: "none",
                    border: "1px solid #aaa",
                    borderRadius: "3px",
                    padding: "4px 8px",
                    width: "100%",
                  }}
                  placeholder="LAT, LON"
                  value={inputValues[input.text]}
                  readOnly
                />
                <input
                  {...register(input.range)}
                  type="number"
                  id={input.range}
                  placeholder="RANGE(m)"
                  style={{
                    marginLeft: "5px",
                    width: "100px",
                    textAlign: "center",
                    outline: "none",
                    border: "1px solid #aaa",
                    borderRadius: "4px",
                    padding: "4px 8px",
                  }}
                  value={inputValues2[input.range]}
                  readOnly
                />
              </div>
            ))}
            <Button
              style={{
                marginBottom: "20px",
              }}
              variant="contained"
              onClick={() => handleButtonClick()}
            >
              Location Setting
            </Button>
            <Input
              {...register("geo")}
              type="hidden"
              defaultValue={postValue}
            />
            <SwitchWrapper>
              <InputLabel>{t(`isSaveLog`)}</InputLabel>
                <Switch
                  id="isSaveLog"
                  {...register("isSaveLog")}
                  checked={watch("isSaveLog") === "y"}
                  onChange={(e) => setValue("isSaveLog", e.target.checked ? "y" : "n")}
                />
	    </SwitchWrapper>
            <InputLabel>{t(`memo (optional)`)}</InputLabel>
            <Input {...register("info")} />
            <Btn>{t(`modify`)}</Btn>
          </InputForm>
        </FormContainer>
      </ModalContainer>
    </Modal>
  );
}

const ModalContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  position: relative;
  padding: 20px;
`;

const Title = styled.h1`
  font-weight: bold;
  font-size: 1.5rem;
  margin-bottom: 30px;
`;

const XBtn = styled.img.attrs({
  src: `${xBtn}`,
})`
  width: 25px;
  height: 25px;
  cursor: pointer;
  position: absolute;
  right: 20px;
  top: 20px;
`;
const FormContainer = styled.div`
  background-color: white;
  border-radius: 10px;
  width: 90%;
  padding: 30px;
`;
const InputForm = styled.form`
  display: flex;
  flex-direction: column;
`;
const InputLabel = styled.label`
  margin-bottom: 10px;
  color: #6b6e6d;
  font-weight: 500;
`;
const Input = styled.input`
  margin-bottom: 15px;
  height: 35px;
  font-size: 1rem;
  border: none;
  border-bottom: 2px solid black;
  &:focus {
    outline: none;
    transition: none;
  }
`;
const Btn = styled.button`
  margin-top: 20px;
  height: 50px;
  width: 100%;
  background-color: #ebecee;
  border: 1px solid #d8d8d8;
  transition: all 0.5s cubic-bezier(0.25, 0.8, 0.25, 1);
  font-weight: bold;
  cursor: pointer;
  font-size: 1rem;
  &:hover {
    background-color: #bddbff;
  }
`;

const ErrorMsg = styled.span`
  height: 30px;
  color: red;
  padding-top: 3px;
  width: 100%;
`;
const Select = styled.select`
  border: none;
  border-bottom: 2px solid black;
  margin-bottom: 15px;
  font-size: 1rem;
`;

const Option = styled.option``;

const SwitchWrapper = styled.div`
  display: flex;
  align-items: baseline;
  margin-bottom: 30px;
  justify-content: space-between;
`;
